export const MALWAREBYTES = {
  modalName: 'malwarebytesModal',
};

export const DOWNLOAD_LINK = 'https://www.malwarebytes.com/';
